enum OauthProvider {
  microsoft
  google
}

enum OauthConsumer {
  nylas
  graph
}

input OauthRedirectInput {
  provider: OauthProvider!
  consumer: OauthConsumer!
  scopes: [String!]
  acre_redirect: String!
}

type OauthAccount {
  id: ID!
  scopes: [String!]
  provider: String
  is_active: Boolean
  username: String!
}

type OrganisationUserOauthAccount {
  credential_id: ID!
  scopes: [String!]
  user_id: String!
  username: String!
}

type OauthCheckResponse {
  credentials: [OauthAccount!]
}

type OauthUserCheckResponse {
  authenticated: [OrganisationUserOauthAccount!]
}
